import storesApi from '../_stores-api.js';
import xorWith from 'lodash/xorWith';
import map from 'lodash/map';
import filter from 'lodash/filter';

export const getStores = async ({ commit, dispatch, state }, lazy) => {
  if (!state.storesCollection.initialized || lazy) {
    let response = await dispatch('async', () => storesApi.getStores(state.storesCollection));

    commit('setStores', response);

    return response;
  }
};

export const filterStores = ({ commit, dispatch }, titleQuery) => {
  commit('setStoresQuery', titleQuery);

  commit('resetStores');

  return dispatch('getStores', false);
};

export const sortStores = ({ commit, dispatch }, sortColumn) => {
  commit('sortStores', sortColumn);

  commit('resetStores');

  return dispatch('getStores', false);
};

export const getStore = async ({ dispatch, commit }, storeId) => {
  let response = await dispatch('async', () => storesApi.getStore(storeId));

  commit('setStore', response.data);

  return response;
};

export const getStoreByUrl = async ({ dispatch, commit }, url) => {
  let response = await dispatch('get', url);

  commit('setStore', response.data);
  
  return response;
};

export const saveOrUpdateStore = async ({ rootState, state, dispatch, commit }, storeId) => {
  let domainId;

  if (rootState.whitelabel.domains && rootState.whitelabel.domains.length && !state.currentStore.domain_id) {
    domainId = rootState.whitelabel.domains[0].domain_id;
  }

  let response = await dispatch('async', () => storesApi.saveOrUpdateStore(storeId, state.currentStore, domainId, state.currentStore.sort_by));

  if (storeId) {
    response = await dispatch('async', () => storesApi.updateCampaigns(storeId, state.currentStore));

    if (state.currentStore.banner_image_data_uri) {
      response = await dispatch('async', () => storesApi.updateBanner(storeId, state.currentStore));
    }

    response = await dispatch('getStoreByUrl', response.store);
  } else {
    response = await dispatch('get', response.store);

    response = await dispatch('async', () => storesApi.updateCampaigns(response.data.id, state.currentStore));
  }

  commit('resetStores');

  return response;
};

export const disableStore = async ({ commit, dispatch }, store) => {
  let response = await dispatch('async', () => storesApi.disableStore(store));

  commit('addNotification', `Collection ${store.name} disabled.`);

  commit('disableStore', store);

  return response;
};

export const getCampaignsByTags = async ({ commit, dispatch, state }, tags) => {
  let response;

  try {
    response = await dispatch('async', () => storesApi.getCampaignsByTags(tags));

    let oldCampaigns = state.currentStore.campaigns || [];

    let newCampaigns = response.data;

    // the first time this function fires, the state.currentStore.campaigns have campaign_id not id.
    let firstFireCampaignIds = filter(oldCampaigns, (el) => el.campaign_id);

    let notIntersection;

    // if the old campaigns are keyed with campaign_id, then we have to do an extra step before we can use xorWith
    // xorWith doesn't work the way you think it will. el1 doesn't always come from the first array, nor does el2 from the second,
    // so we flatten the arrays into primitives first. See https://repl.it/@AlexLowe/xorWith-mixes-up-the-order
    if (firstFireCampaignIds.length > 0) {
      let olds = map(oldCampaigns, (el) => el.campaign_id);

      let news = map(newCampaigns, (el) => el.id);

      notIntersection = xorWith(olds, news, (el1, el2) => el1 == el2);
    } else {
      notIntersection = xorWith(oldCampaigns, newCampaigns, (el1, el2) => el1.id == el2.id);
    }

    // if the campaigns are just re-orderings of each other, then don't bother committing the new campaigns.
    // the old campaigns have a sorting that we want to preserve.
    if (notIntersection.length > 0) {
      commit('setCurrentStoreCampaigns', response.data);
    }
  } catch (error) {
    commit('setCurrentStoreCampaigns', [])
  }
  return response;
};

export const getClientTags = async ({ commit, dispatch, state }) => {
  if (!state.clientTags.length) {
    let response = await dispatch('async', () => storesApi.getClientTags(state.currentStore.domain_id));

    commit('setClientTags', response.data);

    return response;
  }
};

export const toggleActivateStore = async ({ commit, dispatch }, { store, activated }) => {
  let response = await dispatch('async', () => storesApi.toggleActivated(store, activated));

  commit('toggleActivateStore', { store, activated });

  return response;
};

export const deleteStoreBanner = async ({ state, dispatch }) => {
  let response = await dispatch('del', state.currentStore._links.remove_banner.href);

  response = await dispatch('getStoreByUrl', response.store);

  return response;
};